import React, { useEffect, useState } from "react";
import { Row, Col, Card, Container } from "react-bootstrap";
import { toast ,ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  createProjectModule,
  getAllProjectModules,
  updateProjectModule,
  getActiveSprintStories,
} from "../../api/Module";

const ProjectModule = () => {
  const [projectModuleName, setProjectModuleName] = useState("");
  const [modules, setModules] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [stories, setStories] = useState([]);
  const [selectedStories, setSelectedStories] = useState([]);
  const [projectError, setProjectError] = useState("");
  const [subModuleError, setSubModuleError] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await getAllProjectModules(token);
        console.log("moduledata", response.data);
        setModules(response.data);
      } catch (error) {
        console.error("Error fetching modules", error);
      }
    };
    fetchModules();
  }, [token]);

  useEffect(() => {
    const fetchActiveStories = async () => {
      try {
        const response = await getActiveSprintStories(token);
        setStories(response.data);

        console.log("Active sprint stories:", response.data);
      } catch (error) {
        console.error("Error fetching active sprint stories", error);
      }
    };

    fetchActiveStories();
  }, [token]);
  const handleProjectChange = (e) => {
    const { name, value } = e.target;
    if (name !== "projectmodule") return;

    setProjectModuleName(value); // ✅ REQUIRED

    const trimmedValue = value.trim();

    if (value === "") {
      setProjectError("");
      return;
    }

    if (trimmedValue === "") {
      setProjectError("Project Module Name cannot be spaces only");
      return;
    }

    if (/^[0-9]+$/.test(trimmedValue)) {
      setProjectError("Project Module Name cannot be numbers only");
      return;
    }

    if (/^[^a-zA-Z0-9]+$/.test(trimmedValue)) {
      setProjectError(
        "Project Module Name cannot contain only special characters",
      );
      return;
    }

    setProjectError("");
  };
const handleStoryChange = (storyId) => {
  setSelectedStories((prev) => {
    const updated =
      prev.includes(storyId)
        ? prev.filter((id) => id !== storyId)
        : [...prev, storyId];

    // ✅ Remove submodule error when at least one is selected
    if (updated.length > 0) {
      setSubModuleError("");
    }

    return updated;
  });
};

  const handleSubmit = async (e) => {
    e.preventDefault();
  setSubModuleError("");
  setProjectError("");
  let hasError = false;

  const trimmedValue = projectModuleName.trim();

  // ===== Project Module validation =====
  if (!projectModuleName || trimmedValue === "") {
    setProjectError("Project Module Name is required");
    hasError = true;
  } else if (/^[0-9]+$/.test(trimmedValue)) {
    setProjectError("Project Module Name cannot be numbers only");
    hasError = true;
  } else if (/^[^a-zA-Z0-9]+$/.test(trimmedValue)) {
    setProjectError("Project Module Name cannot contain only special characters");
    hasError = true;
  }
if (selectedStories.length === 0) {
  setSubModuleError("Sub Module is required");
  hasError = true;
}

// ❌ STOP SUBMIT if validation failed
if (hasError) return;


    // const payload = { projectModuleName };

    const payload = {
      projectModuleName,
      storyIds: selectedStories, // array of integers
    };

    try {
      if (editId) {
        await updateProjectModule(editId, payload, token);
        toast.success("Project Module updated successfully");
      } else {
        await createProjectModule(payload, token);
        toast.success("Project Module created successfully");
      }

      handleCancel();

      const response = await getAllProjectModules(token);
      setModules(response.data);
    } catch (error) {
      console.error("Error saving project module", error);

      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const handleEdit = (module) => {
    // 1️⃣ Set module name & id
    setProjectModuleName(module.projectModuleName);
    setEditId(module.moduleId);

    // 2️⃣ Extract already allocated story IDs
    const allocatedStoryIds = module.stories.map((s) => s.id);

    // 3️⃣ Merge active stories + allocated stories
    const mergedStories = [
      ...stories,
      ...module.stories.filter((ms) => !stories.some((as) => as.id === ms.id)),
    ];

    // 4️⃣ Update state
    setStories(mergedStories);
    setSelectedStories(allocatedStoryIds);
    setShowDropdown(true);
  };


  const handleCancel = () => {
    setProjectModuleName("");
    setEditId(null);
    setSelectedStories([]); // REQUIRED
    setShowDropdown(false);
    setProjectError("");
  setSubModuleError("");
  };


  const selectedStoryNames = stories
    .filter((story) => selectedStories.includes(story.id))
    .map((story) => story.storyTitle);

  return (
    <>
     <ToastContainer/>
    <Container fluid className="p-4">
    
      <h5 className="mb-2">Reporting/Project Module</h5>
      <Row className="justify-content-center mb-8">
        <Col xl={12} lg={12} md={12} xs={12}>
          <Card>
            <Card.Body>
              <Row className="row g-3 mb-4">
                <form>
                  <Row className="align-items-center" mb-2>
                    <Col md={4}>
                      <label className="form-label mb-0 mt-4">
                        Project Module Name
                        <span className="text-danger">*</span>
                      </label>
                    </Col>

                    <Col md={5}>
                      <input
                        type="text"
                        name="projectmodule"
                        className="form-control mt-4"
                        placeholder="Enter Project Module Name"
                        value={projectModuleName}
                        // onChange={(e) => setProjectModuleName(e.target.value)}
                        onChange={handleProjectChange}
                      />
                      {projectError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.875rem",
                            marginTop: "4px",
                          }}
                        >
                          {projectError}
                        </div>
                      )}
                    </Col>
                  </Row>

                  {/*submodule*/}
                  <Row className="align-items-start mt-3">
                    <Col md={4}>
                      <label className="form-label">
                        Sub Module<span className="text-danger">*</span>
                      </label>
                    </Col>

                    <Col md={5}>
                      <div
                        className="form-control d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowDropdown(!showDropdown)}
                      >
                        <span className="text-muted">
                          {selectedStoryNames.length === 0
                            ? "Select SubModules"
                            : selectedStoryNames.join(", ")}
                        </span>

                        <span>▾</span>
                      </div>

                      {/* Dropdown menu */}
                      {showDropdown && (
                        <div
                          className="border rounded mt-1 p-2 bg-white"
                          style={{ maxHeight: "160px", overflowY: "auto" }}
                        >
                          {stories.length === 0 ? (
                            <p className="text-muted mb-0">No active stories</p>
                          ) : (
                            stories.map((story) => (
                              <div key={story.id} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={selectedStories.includes(story.id)}
                                  onChange={() => handleStoryChange(story.id)}
                                />
                                <label className="form-check-label">
                                  {story.storyTitle}
                                </label>
                              </div>
                            ))
                          )}
                        </div>
                      )}
                      {subModuleError && (
  <div
    style={{
      color: "red",
      fontSize: "0.875rem",
      marginTop: "4px",
    }}
  >
    {subModuleError}
  </div>
)}
                    </Col>
                  </Row>

                  <Row className="text-center mt-3">
                    <Col>
                      <button
                        type="submit"
                        className="btn btn-primary me-2"
                        onClick={handleSubmit}
                      >
                        {editId ? "Update" : "Submit"}
                      </button>

                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    </Col>
                  </Row>
                </form>
              </Row>

              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Project Module Name</th>
                    <th className="text-center" style={{ width: "200px" }}>
                      Action
                    </th>
                  </tr>
                </thead>
               
                <tbody>
                  {modules.length === 0 ? (
                    <tr>
                      <td colSpan="2" className="text-center">
                        No data found
                      </td>
                    </tr>
                  ) : (
                    modules.map((module) => (
                      <tr key={module.moduleId}>
                        <td>{module.projectModuleName}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => handleEdit(module)}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
   
    </>
  );
};

export default ProjectModule;
